import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import en from '../locales/en/translation.json'
import es from '../locales/es/translation.json'
import { brand, platform } from '../lib/platform'

export const SUPPORTED_LOCALES = platform.instance.supportedLanguages as readonly string[]
export type Locale = string
export const DEFAULT_LOCALE: Locale = platform.instance.language

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: SUPPORTED_LOCALES as string[],
    interpolation: {
      escapeValue: false,
      defaultVariables: {
        brandName: brand.name,
        productName: brand.productName,
        legalName: brand.legalName,
        year: String(new Date().getFullYear()),
      },
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'platform.locale',
    },
  })

export default i18n
